import { getYouTubeId } from '@disco/utils/getVideoEmbedURL'

/**
 * Extract YouTube video ID from various YouTube URL formats,
 * including watch, youtu.be, embed, v/ and Shorts URLs.
 */
export const getYouTubeVideoId = (url: string): string | null => {
  // Extract just the URL part (first whitespace-separated token) to handle trailing text
  const cleanUrl = url.trim().split(/\s+/)[0]
  return getYouTubeId(cleanUrl)
}
